import merge from 'deepmerge'
import { path } from '@uswitch/ev-utils/obj'
import { css } from 'theme-ui'

/**
 * Helper which combines a components base and variant themes from theme file.
 *
 * @param {Object} theme - The theme provided by theme ui.
 * @param {string} component - the component you want from the theme file.
 * @param {string[]} variants - The list of variants.
 * @param {string} element - element you require.
 *
 * Example of use can be found in Image Callout Module.
 *
 *
 * @returns {function} A Function which returns element styling from components base and the variants provided.
 */

export default (theme, type, component, variants = []) => element => {
  return merge.all(
    []
      .concat(path([type, component, 'base', element], theme))
      .concat(variants.map(variant => path([type, component, 'variants', variant, element], theme)))
      .filter(i => !!i)
      .map(t => css(t)(theme)),
  )
}
